// extracted by mini-css-extract-plugin
export default {"root":"CompanyUsersHeading_root__hqTwS","wrapper":"CompanyUsersHeading_wrapper__jVU6K","title":"CompanyUsersHeading_title__+0-cO","input":"CompanyUsersHeading_input__+pOvl"};